export const CLAIMS_TYPES = {
  NEW: 'NEW',
  IN_REVIEW: 'IN_REVIEW',
  ON_HOLD: 'ON_HOLD',
  PAID: 'PAID',
  REJECTED: 'REJECTED'
};
export const CLAIMS_TYPES_LIST = [
  CLAIMS_TYPES.NEW,
  CLAIMS_TYPES.IN_REVIEW,
  CLAIMS_TYPES.ON_HOLD,
  CLAIMS_TYPES.PAID,
  CLAIMS_TYPES.REJECTED,
];
export const POLICY_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
};
export const PAYMENT_TYPES = {
  INSURANCE_COMPANY: 'INSURANCE_COMPANY',
  TO_BROKER_AGENT: 'TO_BROKER_AGENT',
};
export const PAYMENT_FORMATS = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMIANNUALLY: 'SEMIANNUALLY',
  ANNUALLY: 'ANNUALLY',
};
export const PAYMENT_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
};
export const TRANSACTION_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
};
export const ACQUISITION_CHANNELS = {
  WEBSITE: 'WEBSITE',
  AGENT: 'AGENT',
  COLD_CALLING: 'COLD_CALLING',
  REFERRAL: 'REFERRAL',
  UNDEFINED: 'UNDEFINED',
};
export const CLAIMS_TYPES_INFO = {
  [CLAIMS_TYPES.NEW]: {
    id: CLAIMS_TYPES.NEW,
    name: 'claims.New',
    color: 'rgba(255, 189, 19, 1)',
    chartWidth: '169px'
  },
  [CLAIMS_TYPES.IN_REVIEW]: {
    id: CLAIMS_TYPES.IN_REVIEW,
    name: 'claims.InReview',
    color: 'rgba(173, 122, 255, 1)',
    chartWidth: '154px'
  },
  [CLAIMS_TYPES.ON_HOLD]: {
    id: CLAIMS_TYPES.ON_HOLD,
    name: 'claims.OnHold',
    color: 'rgba(19, 128, 255, 1)',
    chartWidth: '140px'
  },
  [CLAIMS_TYPES.PAID]: {
    id: CLAIMS_TYPES.PAID,
    name: 'claims.Paid',
    color: 'rgba(88, 219, 77, 1)',
    chartWidth: '127px'
  },
  [CLAIMS_TYPES.REJECTED]: {
    id: CLAIMS_TYPES.REJECTED,
    name: 'claims.Rejected',
    color: 'rgba(255, 141, 122, 1)',
    chartWidth: '115px'
  },
};
export const CLAIMS_GROUPS = [
  {
    stage: CLAIMS_TYPES.NEW,
    name: CLAIMS_TYPES.NEW,
    color: CLAIMS_TYPES_INFO[CLAIMS_TYPES.NEW].color,
  },
  {
    stage: CLAIMS_TYPES.IN_REVIEW,
    name: CLAIMS_TYPES.IN_REVIEW,
    color: CLAIMS_TYPES_INFO[CLAIMS_TYPES.IN_REVIEW].color,
  },
  {
    stage: CLAIMS_TYPES.ON_HOLD,
    name: CLAIMS_TYPES.ON_HOLD,
    color: CLAIMS_TYPES_INFO[CLAIMS_TYPES.ON_HOLD].color,
  },
  {
    stage: CLAIMS_TYPES.PAID,
    name: CLAIMS_TYPES.PAID,
    color: CLAIMS_TYPES_INFO[CLAIMS_TYPES.PAID].color,
  },
  {
    stage: CLAIMS_TYPES.REJECTED,
    name: CLAIMS_TYPES.REJECTED,
    color: CLAIMS_TYPES_INFO[CLAIMS_TYPES.REJECTED].color,
  },
];
export const CLAIMS_LIST = [
  CLAIMS_TYPES.NEW,
  CLAIMS_TYPES.IN_REVIEW,
  CLAIMS_TYPES.ON_HOLD,
  CLAIMS_TYPES.PAID,
  CLAIMS_TYPES.REJECTED,
];

export const PAYMENT_STATUSES_TEXTS = {
  [PAYMENT_STATUSES.PENDING]: 'claims.options.Pending',
  [PAYMENT_STATUSES.RECEIVED]: 'claims.options.Received',
};
export const TRANSACTION_STATUSES_TEXTS = {
  [TRANSACTION_STATUSES.PENDING]: 'claims.options.Pending',
  [TRANSACTION_STATUSES.RECEIVED]: 'claims.options.Received',
};
export const CLAIMS_GROUPS_COLORS = [
  '#FFBD13',
  '#58DB4D',
  '#FF8D7A',
  '#AD7AFF',
  '#52A2FF',
  '#F9F35B',
  '#F95BF3',
  '#6FE1FB',
  '#2DADAD',
  '#6DA25F',
  '#404BAB',
];
export function getRandomColor() {
  return CLAIMS_GROUPS_COLORS[
    Math.floor(Math.random() * CLAIMS_GROUPS_COLORS.length)
  ];
}
